// libs
import React, { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
// ...
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";

function FormModal({setshowformmodalbox, rowdata, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        orderStatusId: "",
        comments: ""
    });
    const disabledField = (orginfo.roleId === 1 || orginfo.roleId === 2) ? false:true;
    const [SubmitButton, setSubmitButton] = useState('UPDATE RECORD');
    const [Notification, setNotification] = useState({ status: false, message: 'Please wait while we fetch your record' });
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [StatusList, setStatusList] = useState([]);
    const [CommentHistory, setCommentHistory] = useState([]);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowformmodalbox(false)
	}

    const updateChangeEvent = (value, field) => {
		field.onChange(value);
	}

    const fetchCommentHistory = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/orders/comments`, {orderId: rowdata.orderId}, token);
        if(apiCall && apiCall.status && Array.isArray(apiCall.context.message.data)) {
            setCommentHistory(apiCall.context.message.data);
        }
    }

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let postData = rowdata;
        postData.orderStatusId = data.orderStatusId;
        postData.comments = data.comments;

        let apiCall = await ajaxCall.patchCall(`${config.api.generic}/orders/update-status`, postData, token);
        if(apiCall && apiCall.status) {
            setSubmitButton('UPDATE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            fetchCommentHistory();
        } else {
            setSubmitButton('UPDATE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }

    const onFulfillmentSubmit = async (data) => {
        setDisableSubmitButton(true);
        const postData = {
            ...rowdata,
            fulfillmentStatus: data.fulfillmentStatus,
            fulfillmentCarrier: data.fulfillmentCarrier,
            trackingNumber: data.trackingNumber,
            trackingUrl: data.trackingUrl
        };
        const apiCall = await ajaxCall.patchCall(`${config.api.generic}/orders/update-fulfillment`, postData, token);
        if(apiCall && apiCall.status) {
            toast.info('Fulfillment updated successfully');
            fetchCommentHistory();
        } else {
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
        }
        setDisableSubmitButton(false);
    }
    
    const fetchStatusList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/orders/status`, {}, token);
        if(apiCall && apiCall.status) {
            setStatusList(apiCall.context.message.data);
        }
    }

    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        fetchStatusList();
        fetchCommentHistory();
        loadComponent();
    }, []);

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>{'Update Order Status'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12" className="mt-3">
                                            <p className="fs-16rem fw-bold">Order Id: {rowdata.orderId}</p>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Order Status</label>
                                            <Controller
                                                name='orderStatusId' 
                                                defaultValue={InputFields.orderStatusId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="orderStatusId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={disabledField}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(StatusList?.orderStatus) && StatusList?.orderStatus.length > 0) ? StatusList?.orderStatus.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.orderStatusId?.type === "required" && "Please update status"}
                                            </small>
                                        </Col>
                                        <Col md="6" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Payment Status</label>
                                            <div className="form-control-plaintext">{rowdata.paymentStatus || 'Managed by payment provider'}</div>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Comments</label>
                                            <textarea defaultValue={InputFields.comments} className="form-control" name="comments" {...register("comments", { required: false, minLength: 5, maxLength: 150 })} disabled={disabledField}></textarea>
                                            <small className="form-text text-danger">
                                                {errors.comments?.type === "required" && "Comments is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.comments?.type === "minLength" && "Enter atleast 5 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.comments?.type === "maxLength" && "Only 150 characters allowed"}
                                            </small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-end text-white mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                        <Col md="12" className="mt-4">
                                            <label className="form-label fs-14rem fw-bold">Fulfillment</label>
                                            <div>
                                                <Row>
                                                    <Col md="6" className="mt-2">
                                                        <label className="form-label fs-14rem">Shipment status</label>
                                                        <select className="form-control custom-select" defaultValue={rowdata.fulfillmentStatus || 'unfulfilled'} {...register('fulfillmentStatus', { required: true })} disabled={disabledField}>
                                                            <option value="unfulfilled">Unfulfilled</option>
                                                            <option value="shipped">Shipped</option>
                                                            <option value="delivered">Delivered</option>
                                                        </select>
                                                    </Col>
                                                    <Col md="6" className="mt-2">
                                                        <label className="form-label fs-14rem">Carrier</label>
                                                        <input className="form-control" defaultValue={rowdata.fulfillmentCarrier || ''} maxLength="100" {...register('fulfillmentCarrier')} disabled={disabledField} />
                                                    </Col>
                                                    <Col md="6" className="mt-2">
                                                        <label className="form-label fs-14rem">Tracking number</label>
                                                        <input className="form-control" defaultValue={rowdata.trackingNumber || ''} maxLength="120" {...register('trackingNumber')} disabled={disabledField} />
                                                    </Col>
                                                    <Col md="6" className="mt-2">
                                                        <label className="form-label fs-14rem">Tracking URL</label>
                                                        <input type="url" className="form-control" defaultValue={rowdata.trackingUrl || ''} maxLength="500" {...register('trackingUrl')} disabled={disabledField} />
                                                    </Col>
                                                    {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                                        <Button variant="primary" type="button" onClick={handleSubmit(onFulfillmentSubmit)} disabled={DisableSubmitButton} className="vt-primary-btn border-0 text-white mt-3 fs-14rem">Save fulfillment</Button>
                                                    </Col> : null}
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col md="12" className="mt-4">
                                            <label className="form-label fs-14rem fw-bold">Order history</label>
                                            <div style={{maxHeight: '250px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '4px', padding: '10px'}}>
                                                {CommentHistory.length > 0 ? CommentHistory.map((item) => (
                                                    <div key={item.pk_id} style={{borderBottom: '1px solid #eee', padding: '8px 0'}}>
                                                        <div className="d-flex justify-content-between align-items-start">
                                                            <p className="mb-1 fs-14rem">{item.comment}</p>
                                                            <small className="text-muted text-nowrap ms-2">{item.date_time}</small>
                                                        </div>
                                                        <div className="d-flex gap-2">
                                                            <span className="badge bg-primary">{item.order_status}</span>
                                                            <span className="badge bg-secondary">{item.payment_status}</span>
                                                        </div>
                                                    </div>
                                                )) : <p className="text-muted fs-14rem mb-0">No comments yet</p>}
                                            </div>
                                        </Col>
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default FormModal;
